export interface IBilledCenterForList {
    donorId: number,
    transplantDate: string,
    chainId: number,
    clusterNumber: number,
    positionNumber: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenterAlias: string,
    donorRdnCenterAlias: string,
    recipientAlias: string,
    recipientCenterId: number,
    recipientCenterAlias: string,
    claimType: string,
    isGlobal: boolean,
    physicianCharges: number,
    hospitalCharges: number,
    anesthesiaCharges: number,
    asaUnitPrice: number,
    asaUnits: number,
    remitDays: number,
    dateSubmittedToRecipientCenter: string,
    invoiceDate: string,
    dateAcceptedByRecipientCenter: string,
    disputedBy: string,
    billedBy: string,
    statusId: number,
    statusDescription: string,
    hasLate: boolean,
    hasOutstandingDelinquency: boolean
}

export interface ISearchForList extends IBilledCenterForList {
    acceptRejectDeadline: string
}